import { useQsQueryParams } from 'hooks/useQueryParams'

export default function useCruiseSelectedCabinType() {
  const { cabinTypes } = useQsQueryParams<{ cabinTypes?: string }>()
  return cabinTypes
}
